import axios from 'axios'

const state = {
  status: '',
  token: localStorage.getItem('jwtToken') || '',
  user: JSON.parse(localStorage.getItem('user')) || {}
}

const mutations = {
  AUTH_REQUEST (state) {
    state.status = 'loading'
  },
  AUTH_SUCCESS (state, payload) {
    state.status = 'success'
    state.token = payload.token
    state.user = payload.user
  },
  AUTH_ERROR (state) {
    state.status = 'error'
  },
  LOGOUT (state) {
    state.status = ''
    state.token = ''
  }
}

const actions = {
  login ({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/auth/login`, user)
        .then(response => {
          const token = response.data.token
          const user = response.data.user
          localStorage.setItem('jwtToken', token)
          localStorage.setItem('user', JSON.stringify(user))
          axios.defaults.headers.common['Authorization'] = token
          commit('AUTH_SUCCESS', { token, user })
          resolve(response)
        })
        .catch(err => {
          commit('AUTH_ERROR', err)
          localStorage.removeItem('jwtToken')
          localStorage.removeItem('user')
          reject(err)
        })
    })
  },
  register ({ state, commit }, payload) {
    // payload must have user and may contain form
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/auth/register/`, payload)
        .then(response => {
          // // for logging in after registering
          // const token = response.data.token
          // const user = response.data.user
          // localStorage.setItem('jwtToken', token)
          // localStorage.setItem('user', JSON.stringify(user))
          // axios.defaults.headers.common['Authorization'] = token
          // commit('AUTH_SUCCESS', { token, user: user })
          commit('AUTH_SUCCESS', { token: state.token, user: state.user })
          resolve(response)
        })
        .catch(err => {
          commit('AUTH_ERROR', err)
          // localStorage.removeItem('jwtToken')
          reject(err)
        })
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('LOGOUT')
      localStorage.removeItem('jwtToken')
      localStorage.removeItem('user')
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  }
}

const getters = {
  isLoggedIn: state => !!state.token,
  isAdmin: state => state.user ? state.user.isAdmin : false,
  authStatus: state => state.status
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
